<template lang="pug">
.rma-initiate(ref="root")
  Modal.is-error(
    v-if="status === 'not_found'"
    width="800px"
    @close="emit('reset-status')"
  )
    span.font-color-red(v-translate) {{ `No record found with webId/email combo: (${formData.orderNumber}, ${formData.email})` }}
  section
    h3 {{ rogue.__('Initiate A Return') }}
    Row
      Column(width="4")
        RogueInput.form-field(
          :label="rogue.__('Order Number')"
          :placeholder="exampleOrder"
          required
          v-model="formData.orderNumber"
          :validate-fn="validateOrderNumber"
        )
      Column(width="4")
        RogueInput.form-field(
          :label="rogue.__('Email Address')"
          placeholder="johndoe@roguefitness.com"
          required
          type="email"
          v-model="formData.email"
        )
      Column(width="4")
        RogueButton.form-field(
          :text="rogue.__('Initiate Return')"
          width="full"
          size="s"
          color="black"
          :loading="processing"
          @click="initReturn"
      )
    p.font-size-xxs.required {{ rogue.__('* Required Fields') }}
  section
    h3 {{ rogue.__('Return Conditions') }}
    Box.return-conditions
      p {{ rogue.__(`You may return or exchange an unused item in new condition within ${deliveryDays} days of delivery.`) }}
      p.font-weight-bold {{ rogue.__('All items must include original packaging.') }}
      p {{ rogue.__('Items that are used or damaged may be denied a refund or exchange.') }}
      p(v-if="['EUR', 'GBR'].includes(rogue.site.code)")
        | {{ rogue.__('If you are planning to make a return from outside the EU, please')}}&nbsp;
        a(@click="router.push('/contact-us')") {{ rogue.__('contact us') }}
        | &nbsp;{{ rogue.__('before you post your return, with the subject line: Outside-EU Return') }}.
  section
    returns-faq
</template>

<script lang="ts" setup>
import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { validateOrderId } from '../helpers'
import ReturnsFaq from '../components/rma-faq.vue'
import { useRogue } from '@/js/services/Rogue'
import { validate } from '@/js/helpers/validate-fns'

const rogue = useRogue()
const route = useRoute()
const router = useRouter()

const root = ref<HTMLElement>()

const props = defineProps({
  order: {
    type     : Object,
    required : false,
  },
  formData: {
    type    : Object,
    default : () => ({}),
  },
  processing: {
    type    : Boolean,
    default : false,
  },
  status: {
    type    : String,
    default : null,
  },
})

const emit = defineEmits(['reset-status', 'order'])

const deliveryDays = computed(() => (['EUR', 'GBR'].includes(rogue.site.code) ? 14 : 30))
const exampleOrder = computed(() => {
  if (['EUR', 'GBR'].includes(rogue.site.code)) {
    return 'Ex: EU000123'
  } if (rogue.site.code === 'AUS') {
    return 'Ex: AUS000123'
  }

  return 'Ex: USC000123'
})

function initReturn() {
  if (!root.value || !validate(root.value!)) {
    return
  }

  emit('order')
}

function validateOrderNumber() {
  const orderNumber = validateOrderId(props.formData.orderNumber)
  if (orderNumber) {
    return rogue.__(orderNumber)
  }

  return null
}
</script>

<style lang="scss" scoped>
.return-conditions p {
  line-height: $line-height-m;
}
.modal:deep() {
  &.is-error .modal-container {
    border: $border-width-medium solid $color-red;
  }

  .modal-body {
    text-align: center;
  }
}
</style>
